export default __webpack_public_path__ + "static/media/back-icon.e826db64.svg";